import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { SharedModule } from '../../../core/modules/shared.module'
import { AuthGuard } from '../../authentication/auth.guard'
import { DashboardComponent } from './dashboard.component'
import { FuseWidgetModule } from '../../../core/components/widget/widget.module'
import { DashboardService } from './service/dashboard.service'
import { TellowConstants } from '../enums/TellowConstants'

const routes = [
  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
]

@NgModule({
  imports: [SharedModule, RouterModule.forRoot(routes), FuseWidgetModule],
  declarations: [DashboardComponent],
  exports: [DashboardComponent],
  providers: [DashboardService, TellowConstants],
})
export class DashboardModule {}



// WEBPACK FOOTER //
// ./src/app/main/content/dashboard/dashboard.module.ts